import { useCallback, useEffect, useState } from 'react'

const isBrowser = typeof window !== 'undefined'

const getStoredValue = <T,>(key: string, fallback: T): T => {
  if (!isBrowser) return fallback
  try {
    const raw = window.localStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw) as T
  } catch (error) {
    console.warn('Yerel depolama okunamadı', error)
    return fallback
  }
}

export function usePersistentState<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => getStoredValue<T>(key, initialValue))

  useEffect(() => {
    setValue(getStoredValue(key, initialValue))
  }, [key, initialValue])

  const updateValue = useCallback(
    (updater: T | ((prev: T) => T)) => {
      setValue((current) => {
        const nextValue = typeof updater === 'function' ? (updater as (prev: T) => T)(current) : updater
        if (isBrowser) {
          try {
            window.localStorage.setItem(key, JSON.stringify(nextValue))
          } catch (error) {
            console.warn('Yerel depolama yazılamadı', error)
          }
        }
        return nextValue
      })
    },
    [key],
  )

  const resetValue = useCallback(() => {
    setValue(initialValue)
    if (isBrowser) {
      try {
        window.localStorage.removeItem(key)
      } catch (error) {
        console.warn('Yerel depolama temizlenemedi', error)
      }
    }
  }, [initialValue, key])

  return [value, updateValue, resetValue] as const
}
